import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-audio-recorder-config-view',
  standalone: true,
  templateUrl: './audio-recorder-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioRecorderConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
